/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomAttributeEntityType } from '../models';
// @ts-ignore
import type { CustomAttributesReorder } from '../models';
// @ts-ignore
import type { CustomAttributesResponse } from '../models';
// @ts-ignore
import type { DeleteCustomAttributeRequest } from '../models';
// @ts-ignore
import type { PatchCustomAttributeRequest } from '../models';
// @ts-ignore
import type { PostCustomAttributeRequest } from '../models';
// @ts-ignore
import type { PostCustomAttributeResponse } from '../models';
/**
 * CustomAttributesApi - axios parameter creator
 * @export
 */
export const CustomAttributesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a custom attribute for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {PostCustomAttributeRequest} postCustomAttributeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomAttribute: async (entityType: CustomAttributeEntityType, postCustomAttributeRequest: PostCustomAttributeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('createCustomAttribute', 'entityType', entityType)
            // verify required parameter 'postCustomAttributeRequest' is not null or undefined
            assertParamExists('createCustomAttribute', 'postCustomAttributeRequest', postCustomAttributeRequest)
            const localVarPath = `/api/v1/customAttributes/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postCustomAttributeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete custom attributes for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {Array<DeleteCustomAttributeRequest>} deleteCustomAttributeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAttribute: async (entityType: CustomAttributeEntityType, deleteCustomAttributeRequest: Array<DeleteCustomAttributeRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('deleteCustomAttribute', 'entityType', entityType)
            // verify required parameter 'deleteCustomAttributeRequest' is not null or undefined
            assertParamExists('deleteCustomAttribute', 'deleteCustomAttributeRequest', deleteCustomAttributeRequest)
            const localVarPath = `/api/v1/customAttributes/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteCustomAttributeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get custom attribute by attribute ID
         * @param {string} attributeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomAttributebyId: async (attributeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attributeId' is not null or undefined
            assertParamExists('getEntityCustomAttributebyId', 'attributeId', attributeId)
            const localVarPath = `/api/v1/customAttributes/{attributeId}`
                .replace(`{${"attributeId"}}`, encodeURIComponent(String(attributeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get custom attributes by entity type
         * @param {Array<CustomAttributeEntityType>} [entityType] 
         * @param {string} [fieldName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomAttributes: async (entityType?: Array<CustomAttributeEntityType>, fieldName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customAttributes/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (entityType) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (fieldName !== undefined) {
                localVarQueryParameter['fieldName'] = fieldName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a custom attribute for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {string} attributeId 
         * @param {PatchCustomAttributeRequest} patchCustomAttributeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomAttribute: async (entityType: CustomAttributeEntityType, attributeId: string, patchCustomAttributeRequest: PatchCustomAttributeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('patchCustomAttribute', 'entityType', entityType)
            // verify required parameter 'attributeId' is not null or undefined
            assertParamExists('patchCustomAttribute', 'attributeId', attributeId)
            // verify required parameter 'patchCustomAttributeRequest' is not null or undefined
            assertParamExists('patchCustomAttribute', 'patchCustomAttributeRequest', patchCustomAttributeRequest)
            const localVarPath = `/api/v1/customAttributes/{entityType}/{attributeId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"attributeId"}}`, encodeURIComponent(String(attributeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchCustomAttributeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder custom attributes for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {Array<CustomAttributesReorder>} customAttributesReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderCustomAttributes: async (entityType: CustomAttributeEntityType, customAttributesReorder: Array<CustomAttributesReorder>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('reorderCustomAttributes', 'entityType', entityType)
            // verify required parameter 'customAttributesReorder' is not null or undefined
            assertParamExists('reorderCustomAttributes', 'customAttributesReorder', customAttributesReorder)
            const localVarPath = `/api/v1/customAttributes/reorder/{entityType}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customAttributesReorder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomAttributesApi - functional programming interface
 * @export
 */
export const CustomAttributesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomAttributesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a custom attribute for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {PostCustomAttributeRequest} postCustomAttributeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomAttribute(entityType: CustomAttributeEntityType, postCustomAttributeRequest: PostCustomAttributeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCustomAttributeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomAttribute(entityType, postCustomAttributeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributesApi.createCustomAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete custom attributes for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {Array<DeleteCustomAttributeRequest>} deleteCustomAttributeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomAttribute(entityType: CustomAttributeEntityType, deleteCustomAttributeRequest: Array<DeleteCustomAttributeRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomAttribute(entityType, deleteCustomAttributeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributesApi.deleteCustomAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get custom attribute by attribute ID
         * @param {string} attributeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomAttributebyId(attributeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAttributesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCustomAttributebyId(attributeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributesApi.getEntityCustomAttributebyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get custom attributes by entity type
         * @param {Array<CustomAttributeEntityType>} [entityType] 
         * @param {string} [fieldName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityCustomAttributes(entityType?: Array<CustomAttributeEntityType>, fieldName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomAttributesResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityCustomAttributes(entityType, fieldName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributesApi.getEntityCustomAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a custom attribute for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {string} attributeId 
         * @param {PatchCustomAttributeRequest} patchCustomAttributeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCustomAttribute(entityType: CustomAttributeEntityType, attributeId: string, patchCustomAttributeRequest: PatchCustomAttributeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCustomAttribute(entityType, attributeId, patchCustomAttributeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributesApi.patchCustomAttribute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder custom attributes for an entity
         * @param {CustomAttributeEntityType} entityType 
         * @param {Array<CustomAttributesReorder>} customAttributesReorder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderCustomAttributes(entityType: CustomAttributeEntityType, customAttributesReorder: Array<CustomAttributesReorder>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderCustomAttributes(entityType, customAttributesReorder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomAttributesApi.reorderCustomAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomAttributesApi - factory interface
 * @export
 */
export const CustomAttributesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomAttributesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a custom attribute for an entity
         * @param {CustomAttributesApiCreateCustomAttributeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomAttribute(requestParameters: CustomAttributesApiCreateCustomAttributeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostCustomAttributeResponse> {
            return localVarFp.createCustomAttribute(requestParameters.entityType, requestParameters.postCustomAttributeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete custom attributes for an entity
         * @param {CustomAttributesApiDeleteCustomAttributeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAttribute(requestParameters: CustomAttributesApiDeleteCustomAttributeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCustomAttribute(requestParameters.entityType, requestParameters.deleteCustomAttributeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get custom attribute by attribute ID
         * @param {CustomAttributesApiGetEntityCustomAttributebyIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomAttributebyId(requestParameters: CustomAttributesApiGetEntityCustomAttributebyIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomAttributesResponse> {
            return localVarFp.getEntityCustomAttributebyId(requestParameters.attributeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get custom attributes by entity type
         * @param {CustomAttributesApiGetEntityCustomAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityCustomAttributes(requestParameters: CustomAttributesApiGetEntityCustomAttributesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomAttributesResponse>> {
            return localVarFp.getEntityCustomAttributes(requestParameters.entityType, requestParameters.fieldName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a custom attribute for an entity
         * @param {CustomAttributesApiPatchCustomAttributeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomAttribute(requestParameters: CustomAttributesApiPatchCustomAttributeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchCustomAttribute(requestParameters.entityType, requestParameters.attributeId, requestParameters.patchCustomAttributeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder custom attributes for an entity
         * @param {CustomAttributesApiReorderCustomAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderCustomAttributes(requestParameters: CustomAttributesApiReorderCustomAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderCustomAttributes(requestParameters.entityType, requestParameters.customAttributesReorder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomAttributesApi - interface
 * @export
 * @interface CustomAttributesApi
 */
export interface CustomAttributesApiInterface {
    /**
     * 
     * @summary Create a custom attribute for an entity
     * @param {CustomAttributesApiCreateCustomAttributeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApiInterface
     */
    createCustomAttribute(requestParameters: CustomAttributesApiCreateCustomAttributeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PostCustomAttributeResponse>;

    /**
     * 
     * @summary Delete custom attributes for an entity
     * @param {CustomAttributesApiDeleteCustomAttributeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApiInterface
     */
    deleteCustomAttribute(requestParameters: CustomAttributesApiDeleteCustomAttributeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get custom attribute by attribute ID
     * @param {CustomAttributesApiGetEntityCustomAttributebyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApiInterface
     */
    getEntityCustomAttributebyId(requestParameters: CustomAttributesApiGetEntityCustomAttributebyIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomAttributesResponse>;

    /**
     * 
     * @summary Get custom attributes by entity type
     * @param {CustomAttributesApiGetEntityCustomAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApiInterface
     */
    getEntityCustomAttributes(requestParameters?: CustomAttributesApiGetEntityCustomAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomAttributesResponse>>;

    /**
     * 
     * @summary Update a custom attribute for an entity
     * @param {CustomAttributesApiPatchCustomAttributeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApiInterface
     */
    patchCustomAttribute(requestParameters: CustomAttributesApiPatchCustomAttributeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Reorder custom attributes for an entity
     * @param {CustomAttributesApiReorderCustomAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApiInterface
     */
    reorderCustomAttributes(requestParameters: CustomAttributesApiReorderCustomAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createCustomAttribute operation in CustomAttributesApi.
 * @export
 * @interface CustomAttributesApiCreateCustomAttributeRequest
 */
export interface CustomAttributesApiCreateCustomAttributeRequest {
    /**
     * 
     * @type {CustomAttributeEntityType}
     * @memberof CustomAttributesApiCreateCustomAttribute
     */
    readonly entityType: CustomAttributeEntityType

    /**
     * 
     * @type {PostCustomAttributeRequest}
     * @memberof CustomAttributesApiCreateCustomAttribute
     */
    readonly postCustomAttributeRequest: PostCustomAttributeRequest
}

/**
 * Request parameters for deleteCustomAttribute operation in CustomAttributesApi.
 * @export
 * @interface CustomAttributesApiDeleteCustomAttributeRequest
 */
export interface CustomAttributesApiDeleteCustomAttributeRequest {
    /**
     * 
     * @type {CustomAttributeEntityType}
     * @memberof CustomAttributesApiDeleteCustomAttribute
     */
    readonly entityType: CustomAttributeEntityType

    /**
     * 
     * @type {Array<DeleteCustomAttributeRequest>}
     * @memberof CustomAttributesApiDeleteCustomAttribute
     */
    readonly deleteCustomAttributeRequest: Array<DeleteCustomAttributeRequest>
}

/**
 * Request parameters for getEntityCustomAttributebyId operation in CustomAttributesApi.
 * @export
 * @interface CustomAttributesApiGetEntityCustomAttributebyIdRequest
 */
export interface CustomAttributesApiGetEntityCustomAttributebyIdRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomAttributesApiGetEntityCustomAttributebyId
     */
    readonly attributeId: string
}

/**
 * Request parameters for getEntityCustomAttributes operation in CustomAttributesApi.
 * @export
 * @interface CustomAttributesApiGetEntityCustomAttributesRequest
 */
export interface CustomAttributesApiGetEntityCustomAttributesRequest {
    /**
     * 
     * @type {Array<CustomAttributeEntityType>}
     * @memberof CustomAttributesApiGetEntityCustomAttributes
     */
    readonly entityType?: Array<CustomAttributeEntityType>

    /**
     * 
     * @type {string}
     * @memberof CustomAttributesApiGetEntityCustomAttributes
     */
    readonly fieldName?: string
}

/**
 * Request parameters for patchCustomAttribute operation in CustomAttributesApi.
 * @export
 * @interface CustomAttributesApiPatchCustomAttributeRequest
 */
export interface CustomAttributesApiPatchCustomAttributeRequest {
    /**
     * 
     * @type {CustomAttributeEntityType}
     * @memberof CustomAttributesApiPatchCustomAttribute
     */
    readonly entityType: CustomAttributeEntityType

    /**
     * 
     * @type {string}
     * @memberof CustomAttributesApiPatchCustomAttribute
     */
    readonly attributeId: string

    /**
     * 
     * @type {PatchCustomAttributeRequest}
     * @memberof CustomAttributesApiPatchCustomAttribute
     */
    readonly patchCustomAttributeRequest: PatchCustomAttributeRequest
}

/**
 * Request parameters for reorderCustomAttributes operation in CustomAttributesApi.
 * @export
 * @interface CustomAttributesApiReorderCustomAttributesRequest
 */
export interface CustomAttributesApiReorderCustomAttributesRequest {
    /**
     * 
     * @type {CustomAttributeEntityType}
     * @memberof CustomAttributesApiReorderCustomAttributes
     */
    readonly entityType: CustomAttributeEntityType

    /**
     * 
     * @type {Array<CustomAttributesReorder>}
     * @memberof CustomAttributesApiReorderCustomAttributes
     */
    readonly customAttributesReorder: Array<CustomAttributesReorder>
}

/**
 * CustomAttributesApi - object-oriented interface
 * @export
 * @class CustomAttributesApi
 * @extends {BaseAPI}
 */
export class CustomAttributesApi extends BaseAPI implements CustomAttributesApiInterface {
    /**
     * 
     * @summary Create a custom attribute for an entity
     * @param {CustomAttributesApiCreateCustomAttributeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApi
     */
    public createCustomAttribute(requestParameters: CustomAttributesApiCreateCustomAttributeRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributesApiFp(this.configuration).createCustomAttribute(requestParameters.entityType, requestParameters.postCustomAttributeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete custom attributes for an entity
     * @param {CustomAttributesApiDeleteCustomAttributeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApi
     */
    public deleteCustomAttribute(requestParameters: CustomAttributesApiDeleteCustomAttributeRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributesApiFp(this.configuration).deleteCustomAttribute(requestParameters.entityType, requestParameters.deleteCustomAttributeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get custom attribute by attribute ID
     * @param {CustomAttributesApiGetEntityCustomAttributebyIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApi
     */
    public getEntityCustomAttributebyId(requestParameters: CustomAttributesApiGetEntityCustomAttributebyIdRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributesApiFp(this.configuration).getEntityCustomAttributebyId(requestParameters.attributeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get custom attributes by entity type
     * @param {CustomAttributesApiGetEntityCustomAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApi
     */
    public getEntityCustomAttributes(requestParameters: CustomAttributesApiGetEntityCustomAttributesRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomAttributesApiFp(this.configuration).getEntityCustomAttributes(requestParameters.entityType, requestParameters.fieldName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a custom attribute for an entity
     * @param {CustomAttributesApiPatchCustomAttributeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApi
     */
    public patchCustomAttribute(requestParameters: CustomAttributesApiPatchCustomAttributeRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributesApiFp(this.configuration).patchCustomAttribute(requestParameters.entityType, requestParameters.attributeId, requestParameters.patchCustomAttributeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder custom attributes for an entity
     * @param {CustomAttributesApiReorderCustomAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributesApi
     */
    public reorderCustomAttributes(requestParameters: CustomAttributesApiReorderCustomAttributesRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributesApiFp(this.configuration).reorderCustomAttributes(requestParameters.entityType, requestParameters.customAttributesReorder, options).then((request) => request(this.axios, this.basePath));
    }
}

